import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { DashboardCardConfig, DashboardCardId, getDashboardCard } from '../dashboard-cards.config';

@Component({
	selector: 'app-dashboard-metric-card',
	templateUrl: './dashboard-metric-card.component.html',
	standalone: false,
	changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DashboardMetricCardComponent {
	@Input({ required: true }) public card: DashboardCardId;
	@Input() public value: string | number | null = null;
	@Input() public sublabel: string | number | null = null;
	@Input() public labelSuffix: string | null = null;
	@Input() public loading: boolean = false;
	@Input() public hasAction: boolean = true;
	@Output() public action: EventEmitter<void> = new EventEmitter<void>();

	public get config(): DashboardCardConfig {
		return getDashboardCard(this.card);
	}

	public get labelSuffixText(): string {
		return this.labelSuffix ? ` (${this.labelSuffix})` : '';
	}

	public get showAction(): boolean {
		return this.action.observed && this.hasAction;
	}
}
